<template>
    <div>
        <ActsFilter :filter-model="filter" @applyFilter="applyFilter" @resetFilter="resetFilter" />
        <ActsTable
            :headers="headers"
            :items="acts"
            :items-length="itemsLength"
            :items-per-page="itemsPerPage"
            :is-loading="isLoading"
            :page.sync="page"
            :selected.sync="selectedAccounts"
            ref="actTable"
        />
    </div>
</template>

<script>
import ActsTable from '@/components/acts/ActsTable.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import translate from '@/utils/translate.util';
import ActsService from '@/services/apiRequests/acts.service';
import ActsFilter from '@/components/acts/ActsFilter.vue';

export default {
    name: 'accountsActs',
    components: { ActsFilter, ActsTable },
    data: function() {
        return {
            headers: [
                {
                    text: 'Номер лицевого счета<br>ФИО по лицевому счету',
                    value: 'serial_number',
                    width: 270
                },
                {
                    text: 'Адрес',
                    value: 'address',
                    width: 200
                },
                {
                    text: 'Состояние услуг',
                    value: 'services',
                    width: 290
                },
                {
                    text: 'Досудебное<br>уведомление',
                    value: 'preTrialNoticeDate',
                    width: 200
                },
                {
                    text: 'Сведения<br>по задолженности',
                    value: 'debts_info',
                    width: 200,
                    align: 'end'
                }
            ],
            actsHeaders: [
                {
                    text: 'Номер акта<br>Дата акта<br>Статус акта',
                    value: 'act_number',
                    width: 200
                },
                {
                    text: 'Услуга<br> Действие<br> Дата действия<br> Причина',
                    value: 'action_name',
                    width: 200
                },
                {
                    text: 'Предписание<br>Срок исполнения<br>Статус',
                    value: 'valid_begin',
                    width: 180
                },
                {
                    text: 'Контролер<br>ФИО',
                    value: 'Inspectors',
                    width: 200
                },
                {
                    text: 'Инженер<br>ФИО',
                    value: 'engineer_full_name',
                    width: 200
                },
                {
                    text: 'Комментарий',
                    value: 'comment',
                    width: 140
                }
            ],
            page: 1,
            selectedAccounts: [],
            filter: {
                id: null,
                address: {},
                date: null,
                is_connected_gvs: null,
                is_connected_heat: null,
                engineer_name: null,
                is_debtor: null,
                engineer_rid: null
            }
        };
    },
    provide() {
        return {
            actsHeaders: this.actsHeaders,
            getActsDetails: this.getAccountActsDetails,
            actDelete: this.actDelete,
            actPrint: this.actPrint,
            actSendEmail: this.actSendEmail,
            getInfoCreate: this.getInfoCreate,
            saveAct: this.saveAct,
            getActPdf: this.getActPdf,
            getActSignInfo: this.getActSignInfo,
            postActSign: this.postActSign,
            getSignedDocument: this.getSignedDocument,
            actSign: this.actSign
        };
    },
    computed: {
        ...mapGetters('acts', ['getAccountActs', 'getAccountRowCount', 'getAccountIsLoading', 'getAccountItemsPerPage', 'getAccountPage']),
        acts() {
            return translate(this.getAccountActs, 'full', this.$i18n.locale);
        },
        itemsLength() {
            return this.getAccountRowCount;
        },
        isLoading() {
            return this.getAccountIsLoading;
        },
        itemsPerPage() {
            return this.getAccountItemsPerPage;
        }
    },
    methods: {
        ...mapActions('acts', ['getAccountActsData', 'setAccountActsFilter', 'printAccountActPdf']),
        ...mapMutations('acts', ['setAccountPage']),
        async getAccountActsDetails(item) {
            const payload = {
                account_rid: item['account_rid'],
                date_begin: this.filter.date ? this.filter.date[0] : null,
                date_end: this.filter.date ? this.filter.date[1] ?? this.filter.date[0] : null,
                signed: this.filter.signed
            };
            const response = await ActsService.getAccountActsDetails(payload);
            if (response.successfull && !response.data['accounts_acts']) return [];
            if (!response.successfull) return [];
            return response.data['accounts_acts'];
        },
        async applyFilter() {
            this.setAccountActsFilter(this.filter);
            this.setAccountPage(0);
            await this.getAccountActsData();
        },
        async resetFilter() {
            this.page = 1;
            this.selectedContracts = [];
            this.filter = {
                id: null,
                address: {},
                date: null,
                is_connected_gvs: null,
                is_connected_heat: null,
                engineer_name: null,
                is_debtor: null,
                engineer_rid: null
            };
            this.setAccountPage(0);
            this.setAccountActsFilter(this.filter);
            await this.getAccountActsData();
        },
        async actDelete(id) {
            await ActsService.deleteAccountAct(id);
        },
        async actPrint(id) {
            await this.printAccountActPdf([id]);
        },
        async actSign(id) {
            this.$refs.actTable.actSign(id);
        },
        async actSendEmail(act) {
            const payload = {
                act_rid: act['act_rid'],
                email: act['e_mail']
            };
            await ActsService.sendEmailAccountAct(payload);
        },
        getInfoCreate(account_rid) {
            return ActsService.getInfoCreateAccountAct(account_rid);
        },
        saveAct(payload) {
            return ActsService.addAccountAct(payload);
        },
        getActPdf(record_id) {
            const payload = { acts: [record_id] };
            return ActsService.getAccountActPDF(payload);
        },
        getActSignInfo(act_rid) {
            return ActsService.getAccountActInfoToSign(act_rid);
        },
        postActSign(payload) {
            return ActsService.postAccountActSign(payload);
        },
        async getSignedDocument(guid) {
            const response = await this.$store.dispatch('documents/getSignedDocument', {
                guid: guid
            });

            if (!response) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Нет данных',
                    color: 'warning'
                });
            }
        }
    },
    watch: {
        page: {
            async handler(newPage, oldPage) {
                if (newPage === 1) {
                    this.setAccountPage(0);
                } else if (oldPage < newPage) {
                    this.setAccountPage(this.getAccountPage + this.getAccountItemsPerPage);
                } else {
                    this.setAccountPage(this.getAccountPage - this.getAccountItemsPerPage);
                }
                await this.getAccountActsData();
            },
            immediate: true
        }
    }
};
</script>

<style scoped></style>
